// src/environments/environment.uat.ts
export const environment = {
  production: false,
  apiUrl: 'https://erpbackoffice-uat.azurewebsites.net/api',
  features: {
    enableDebug: false,
    mockServices: false,
  },
  auth: {
    authority: 'https://login.microsoftonline.com/',
  },
  azureAd: {
    tenantId: 'a5007cc8-afde-49bd-ab48-17668897ebdd',
    clientId: '878dc03b-2598-4356-b451-32010ac1547b',
    redirectUri: 'https://backoffice-uat.essentialskills.lu',
    scopes: [
      'api://878dc03b-2598-4356-b451-32010ac1547b/access_as_user',
      'openid',
      'profile',
      'email',
      'offline_access',
    ],
  },
  moodle: {
    baseUrl: 'https://apprenant-uat.cnfpc.lu',
    moodleFormationIdUrl: '/blocks/cnfpc_catalogue/details.php?courseid=',
  },
};
